import { render } from "./PremiumTrajectory.vue?vue&type=template&id=20b55f19&scoped=true"
import script from "./PremiumTrajectory.vue?vue&type=script&lang=js"
export * from "./PremiumTrajectory.vue?vue&type=script&lang=js"

import "./PremiumTrajectory.vue?vue&type=style&index=0&id=20b55f19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b55f19"]])

export default __exports__